import { h } from "@stencil/core";
import { getActualLanguageWithoutAlias, parseCodeToHAST, registerLanguage } from "@genexus/markdown-parser/dist/parse-code.js";
const checkIfIsLastNestedChild = (element, lastNestedChild) => element === lastNestedChild;
const codeToJSXDictionary = {
    element: (element, lastNestedChildClass, lastNestedChild) => {
        const className = element.properties.className;
        const addLastNestedChildClass = checkIfIsLastNestedChild(element, lastNestedChild);
        const highlightJSClasses = className ? className.join(" ") : undefined;
        return (h("span", { class: {
                [highlightJSClasses]: !!highlightJSClasses,
                [lastNestedChildClass]: addLastNestedChildClass
            } }, renderCodeChildren(element, lastNestedChildClass, lastNestedChild)));
    },
    text: (element) => element.value
};
function renderCodeChildren(element, lastNestedChildClass, lastNestedChild) {
    return element.children.map(child => codeToJSXDictionary[child.type](child, lastNestedChildClass, lastNestedChild));
}
const findLastNestedChild = (elementWithChildren) => {
    const lastChild = elementWithChildren.children.at(-1);
    // The last element have children. We must check its sub children
    if (lastChild.children?.length > 0) {
        return findLastNestedChild(lastChild);
    }
    return elementWithChildren;
};
export const parseCodeToJSX = async (code, language, shouldFindLastNestedChild, lastNestedChildClass) => {
    const actualLanguage = getActualLanguageWithoutAlias(language);
    // Register the language
    await registerLanguage(actualLanguage);
    const tree = parseCodeToHAST(actualLanguage, code);
    // Find last nested child
    const lastNestedChild = shouldFindLastNestedChild
        ? findLastNestedChild(tree)
        : undefined;
    return {
        renderedCode: renderCodeChildren(tree, lastNestedChildClass, lastNestedChild),
        lastNestedChildIsRoot: tree === lastNestedChild
    };
};
